import React from "react";
import About from "../components/About/About";
import EventSection from "../components/EventSection/EventSection";
import classes from "./AboutPage.module.css";
import TShirt from "../components/TShirt/TShirt"; 


const AboutPage = () => {
    return (
        <>
            <div className={classes.about_page}>
                <h1 className={classes.headingx}>About</h1>
                <About />
                <EventSection />
                <TShirt />
            </div>
        </>
    );
};

export default AboutPage;
